<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>
        Zosuvy a iné svahové deformácie, lokalita
        {{ lokalita.Name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon :to="{ name: 'PublicHome' }">
            <v-icon v-on="on">mdi-keyboard-return</v-icon>
          </v-btn>
        </template>
        <span>Návrat na mapu zosunov</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-tabs>
          <v-tab>Mapa</v-tab>
          <v-tab>Info</v-tab>
          <v-tab v-if="insars.length > 0">Insar</v-tab>
          <v-tab v-if="posunyBodov.length > 0"
            >Geodézia - pohybová aktivita</v-tab
          >
          <v-tab v-if="posunyInkBodov.length > 0">Presná inklinometria</v-tab>

          <v-tab-item>
            <v-container fluid class="mt-2 elevation-3">
              <l-map
                :zoom="zoom"
                :center="center"
                style="height: 600px; width: 100%; z-index: 0"
                ref="map"
                :bounds="bounds"
              >
                <l-control-scale
                  position="topright"
                  :imperial="false"
                  :metric="true"
                ></l-control-scale>
                <l-control position="bottomleft">
                  <v-img :src="require('../assets/logo_SGUDS_cb.svg')"></v-img>
                </l-control>
                <l-control position="bottomright">
                  <v-img :src="require('../assets/nautical.svg')"></v-img>
                </l-control>
                <l-control-layers position="topright"></l-control-layers>
                <l-tile-layer
                  v-for="tileProvider in tileProviders"
                  :key="tileProvider.name"
                  :name="tileProvider.name"
                  :visible="tileProvider.visible"
                  :url="tileProvider.url"
                  :attribution="tileProvider.attribution"
                  layer-type="base"
                />
                <l-geo-json
                  v-if="geojson !== null"
                  :geojson="geojson"
                  :options="{ onEachFeature: onEachFeatureFunction }"
                  :optionsStyle="{ color: 'red' }"
                ></l-geo-json>
                <l-control position="topright" v-if="lokalitaHasVrty">
                  <v-btn @click="showVrty = !showVrty">
                    {{ this.showVrty ? "Schovať vrty" : "Zobraziť vrty" }}
                  </v-btn>
                </l-control>
                <template v-if="showVrty && lokalitaHasVrty">
                  <l-geo-json
                    v-for="(gj, index) in bodyGeojsons"
                    :key="'gj' + index"
                    :geojson="gj"
                    :options="{ onEachFeature: onEachFeatureFunction }"
                    :optionsStyle="{ color: 'blue' }"
                  ></l-geo-json>
                </template>
                <template v-if="lokalita.Body.length > 0">
                  <template v-for="bod in lokalita.Body">
                    <l-marker
                      v-if="bod.Lat != 0 && bod.Lng != 0"
                      :lat-lng="[bod.Lat, bod.Lng]"
                      :key="bod.ID"
                      @click="viewBod(bod)"
                    >
                      <l-tooltip>{{ bod.ZNMB }}</l-tooltip>
                    </l-marker>
                  </template>
                </template>
              </l-map>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid class="mt-2 elevation-3">
              <v-row dense>
                <v-col md="2" class="font-weight-black">Lokalita:</v-col>
                <v-col>{{ lokalita.Name }}</v-col>
                <v-col md="2" class="font-weight-black"
                  >Katastrálne územie:</v-col
                >
                <v-col>
                  <span v-if="jeKU">{{ lokalita.KU.NM5 }}</span>
                </v-col>
              </v-row>
              <v-row dense v-if="jeKU">
                <v-col md="2" class="font-weight-black">Obec:</v-col>
                <v-col>{{ lokalita.KU.NM4 }}</v-col>
                <v-col md="2" class="font-weight-black">Okres:</v-col>
                <v-col>{{ lokalita.KU.NM3 }}</v-col>
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black"
                  >Názov inž.geol. regiónu:</v-col
                >
                <v-col md="4">{{ lokalita.IgReg }}</v-col>
                <v-col md="2" class="font-weight-black"
                  >Názov inž.geol. oblasti:</v-col
                >
                <v-col md="4">{{ lokalita.IgObl }}</v-col>
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black">Plocha:</v-col>
                <v-col md="4">
                  {{ lokalita.Plocha }} m
                  <sup>2</sup>
                </v-col>
                <v-col md="2" class="font-weight-black">Nadmorská výška:</v-col>
                <v-col md="4"
                  >{{ lokalita.Nadm1 }} - {{ lokalita.Nadm2 }} m.n.m.</v-col
                >
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black">Objem:</v-col>
                <v-col md="4">
                  {{ lokalita.Objem }} m
                  <sup>3</sup>
                </v-col>
                <v-col md="2" class="font-weight-black">Obdobie:</v-col>
                <v-col md="4">{{ getObdobieString }}</v-col>
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black">Popis:</v-col>
                <v-col>{{ lokalita.Popis }}</v-col>
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black">Literatúra:</v-col>
                <v-col>
                  <div v-for="lit in lokalita.Literatura" :key="lit.ID">
                    {{ lit.Literatura }}
                  </div>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col md="2" class="font-weight-black">Zoznam bodov:</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-data-table
                    :headers="bodyheaders"
                    :items="lokalita.Body"
                    :items-per-page="10"
                    sort-by="IDMB"
                    class="elevation-1 clickableTable"
                    :custom-sort="customSort"
                    dense
                    @click:row="viewBod($event)"
                  >
                    <template v-slot:item.merania="{ item }">
                      <template v-for="meranie in merania">
                        <span
                          :key="meranie"
                          style="display: inline-block; width: 30px"
                          v-if="getMeranieCountIconName(item, meranie) !== ''"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">
                                {{ getMeranieCountIconName(item, meranie) }}
                              </v-icon>
                            </template>
                            <span>
                              {{ getMeranieCountText(item, meranie) }} -
                              {{ getMeranieCountPocet(item, meranie) }}
                            </span>
                          </v-tooltip>
                        </span>
                      </template>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="insars.length > 0" eager>
            <v-container fluid class="mt-2 elevation-3">
              <v-row dense>
                <v-col cols="12">
                  <v-select :items="insars" label="Meranie" v-model="insar">
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.Filename }}
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.Filename"
                        ></v-list-item-title>
                        <v-list-item-subtitle>
                          <b>Misia:</b> {{ item.Misia }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <b>Poznámka:</b> {{ item.Poznamka }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="insar.Image">
                  <v-img :src="'data:image/jpeg;base64,' + insar.Image" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="posunyBodov.length > 0">
            <v-container fluid class="mt-2 elevation-3">
              <geo-pohybova-aktivita
                :body="posunyBodov"
                :bounds="bounds"
              ></geo-pohybova-aktivita>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="posunyInkBodov.length > 0">
            <v-container fluid class="mt-2 elevation-3">
              <ink-pohybova-aktivita
                :lokalitaId="lokalita.ID"
                :posuny="posunyInkBodov"
                :lokalitaMinYear="lokalita.RokOd"
                :lokalitaMaxYear="lokalita.RokDo"
              ></ink-pohybova-aktivita>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-container>
      <v-container fluid>
        <h4 v-if="bod.ID">Bod: {{ bod.ZNMB }}</h4>
        <div v-if="bod.HpvsCount > 0">
          <hpv-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
        <div v-if="bod.HpvqsCount > 0">
          <hpvq-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
        <div v-if="bod.GeosCount > 0">
          <geo-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
        <div v-if="bod.InkpsCount > 0">
          <ink-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
        <div v-if="bod.MikrosCount > 0">
          <mikro-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
        <div v-if="bod.StabsCount > 0">
          <stabskal-public-chart
            :bod="bod"
            :minYear="lokalita.RokOd"
            :maxYear="lokalita.RokDo"
          />
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import * as L from "leaflet"
import {
  LMap,
  LTileLayer,
  LTooltip,
  LMarker,
  LGeoJson,
  LControl,
  LControlLayers,
  LControlScale
} from "vue2-leaflet"
import * as Miscella from "../plugins/miscella.js"
import * as Enums from "../plugins/enums.js"
//import HeatmapOverlay from "leaflet-heatmap"
import GeoPohybovaAktivita from "../components/GeoPohybovaAktivita.vue"
import InkPohybovaAktivita from "../components/InkPohybovaAktivita.vue"
import HpvPublicChart from "../components/charts/PublicHpv.vue"
import HpvqPublicChart from "../components/charts/PublicHpvq.vue"
import GeoPublicChart from "../components/charts/PublicGeo.vue"
import InkPublicChart from "../components/charts/PublicInk.vue"
import MikroPublicChart from "../components/charts/PublicMikro.vue"
import StabskalPublicChart from "../components/charts/PublicStabskal.vue"

export default {
  props: ["id"],
  components: {
    LGeoJson,
    LMap,
    LMarker,
    LTileLayer,
    LTooltip,
    HpvPublicChart,
    HpvqPublicChart,
    GeoPublicChart,
    GeoPohybovaAktivita,
    InkPohybovaAktivita,
    InkPublicChart,
    MikroPublicChart,
    StabskalPublicChart,
    LControl,
    LControlLayers,
    LControlScale
  },

  data: () => ({
    tab: 0,
    lokalita: {
      ID: null,
      Name: "",
      Body: [],
      Stanice: []
    },
    insars: [],
    heatmapLayer: null,
    heatmapData: null,
    heatMin: 0,
    heatMax: 0,
    mycolors: [
      "#FF0000ff",
      "#FF4040ff",
      "#FF8080ff",
      "#FFBFBFff",
      "#FFFFFFff",
      "#CCCFFFff",
      "#99A0FFff",
      "#6670FFff",
      "#3341FFff",
      "#0011FFff"
    ],
    showVrty: true,
    bodyGeojsons: [],
    geojson: null,
    bounds: null,
    insar: {
      Body: []
    },
    bod: {},
    merania: Enums.TYPY,
    bodyheaders: [
      { text: "ID", align: "left", sortable: true, value: "IDMB" },
      { text: "ZNMB", align: "left", sortable: true, value: "ZNMB" },
      {
        text: "Dátum od",
        align: "left",
        sortable: true,
        value: "DatumOdString"
      },
      {
        text: "Dátum do",
        align: "left",
        sortable: true,
        value: "DatumDoString"
      },
      { text: "X", align: "right", sortable: false, value: "X" },
      { text: "Y", align: "right", sortable: false, value: "Y" },
      { text: "Z", align: "right", sortable: false, value: "Z" },
      { text: "", align: "right", sortable: false, value: "merania" }
    ],

    mapOptions: {
      zoomSnap: 0.5
    },

    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    posunyBodov: [],
    posunyInkBodov: [],
    customSort: Miscella.customSort,
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),
  computed: {
    lokalitaHasVrty: function() {
      let ret = false
      for (let i = 0; i < this.lokalita.Body.length; i++) {
        const bod = this.lokalita.Body[i]
        if (bod.GeomLines && bod.GeomLines !== "") {
          ret = true
        }
      }
      return ret
    },
    jeKU: function() {
      let ret = false
      if (Miscella.isSet(this.lokalita.KU)) {
        if (this.lokalita.KU.ObjectID !== 0) {
          ret = true
        }
      }
      return ret
    },
    getObdobieString: function() {
      let ret = this.lokalita.DatumOdString
      if (ret !== "") {
        ret += " - "
      }
      ret += this.lokalita.DatumDoString
      return ret
    },
    bodPopupOptions: function() {
      return {
        minWidth: 500,
        autoPanPaddingTopLeft: L.point(50, 10)
      }
    }
  },
  watch: {
    insar: {
      deep: true,
      handler() {
        console.log("insar changed")
      }
    }
  },
  methods: {
    readLokalita: async function(id) {
      console.log("Lokalita.vue, readLokalita, id=" + id)
      try {
        let response = await this.$axios.get("/lokalita/" + id)
        if (response.status === 200) {
          this.lokalita = this.transformItem(response.data)
          if (this.lokalita.Geometria && this.lokalita.Geometria !== "") {
            this.geojson = {
              type: "Feature",
              properties: {
                name: this.lokalita.Name,
                description: this.lokalita.Popis
              },
              geometry: JSON.parse(this.lokalita.Geometria)
            }
            var bbox = this.geojson.geometry.bbox
            this.bounds = [
              L.latLng(bbox[1], bbox[0]),
              L.latLng(bbox[3], bbox[2])
            ]
          } else {
            //vypocitaj bounds z bodov
            let latMin = null
            let latMax = null
            let lngMin = null
            let lngMax = null
            console.log("Setting bounds 0")
            for (let i = 0; i < this.lokalita.Body.length; i++) {
              const bod = this.lokalita.Body[i]
              if (bod.Lng && bod.Lat) {
                if (i === 0 || latMin === null) {
                  latMin = bod.Lat
                  latMax = bod.Lat
                  lngMin = bod.Lng
                  lngMax = bod.Lng
                } else {
                  latMin = Math.min(latMin, bod.Lat)
                  latMax = Math.max(latMax, bod.Lat)
                  lngMin = Math.min(lngMin, bod.Lng)
                  lngMax = Math.max(lngMax, bod.Lng)
                }
              }
            }
            this.bounds = [
              [latMax, lngMin],
              [latMin, lngMax]
            ]
            console.log("Setting bounds to", this.bounds)
          }
          for (let i = 0; i < this.lokalita.Body.length; i++) {
            const bod = this.lokalita.Body[i]
            if (bod.GeomLines && bod.GeomLines !== "") {
              let bodGeojson = {
                type: "Feature",
                properties: {
                  name: bod.ZNMB,
                  description: bod.Poznamka
                },
                geometry: JSON.parse(bod.GeomLines)
              }
              this.bodyGeojsons.push(bodGeojson)
            }
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readInsars: async function(id) {
      try {
        let response = await this.$axios.get(`/lokalita/${id}/insars`)
        if (response.status === 200) {
          let arr = response.data
          for (let i = 0; i < arr.length; i++) {
            if (Miscella.isSet(arr[i].Image)) {
              this.insars.push(arr[i])
            }
          }
          if (this.insars.length > 0) {
            this.insar = this.insars[0]
          } else {
            this.insar = {}
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readPosunyBodov: async function(id) {
      try {
        let response = await this.$axios.get(`/lokalita/${id}/posunyBodov`)
        if (response.status === 200) {
          this.posunyBodov = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readPosunyInkBodov: async function(id) {
      try {
        let response = await this.$axios.get(
          `/lokalita/${id}/posunyInkBodov?rokOd=${this.lokalita.RokOd}&rokDo=${this.lokalita.RokDo}`
        )
        if (response.status === 200) {
          this.posunyInkBodov = response.data.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    transformItem: function(item) {
      item.DatumOd = Miscella.zeroDatum(item.DatumOd)
      item.DatumDo = Miscella.zeroDatum(item.DatumDo)
      item.DatumOdString = Miscella.formatDatum(item.DatumOd)
      item.DatumDoString = Miscella.formatDatum(item.DatumDo)
      for (let i = 0; i < item.Body.length; i++) {
        let bod = item.Body[i]
        bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
        bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
        bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
        bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
      }
      return item
    },
    viewBod: async function(bod) {
      console.log("BOD, readBod")
      try {
        let response = await this.$axios.get("/r/bod/" + bod.ID)
        if (response.status === 200) {
          let item = response.data
          item.DatumOd = Miscella.zeroDatum(item.DatumOd)
          item.DatumDo = Miscella.zeroDatum(item.DatumDo)
          item.DatumOdString = Miscella.formatDatum(item.DatumOd)
          item.DatumDoString = Miscella.formatDatum(item.DatumDo)
          this.bod = item
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    onEachFeatureFunction: function(feature, layer) {
      layer.bindPopup(
        "<h4>" +
          feature.properties.name +
          "</h4><p>" +
          feature.properties.description +
          "</p>",
        { permanent: false, sticky: true }
      )
    },
    getMeranieCountIconName: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.iconName
    },
    getMeranieCountText: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.text
    },
    getMeranieCountPocet: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.pocet
    },
    getMeranieCountItem: function(bod, meranie) {
      let ret = Enums.getMeranieCountItem(bod, meranie)
      ret.text = "Počet vykonaných meraní: " + ret.text
      return ret
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokalita(this.id)
    this.readInsars(this.id)
    this.readPosunyBodov(this.id)
    this.readPosunyInkBodov(this.id)
  }
}
</script>
<style></style>
